// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.safq-plugin-card {
  margin-bottom: 10px;
}
.safq-plugin-card .title {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
}
.safq-plugin-card .action button {
  border-style: none;
  padding: 0;
  margin: 0;
  background-color: transparent;
  color: var(--store-addons-for-woocommerce-color);
  text-decoration: none;
}`, "",{"version":3,"sources":["webpack://./src/components/PluginCard/PluginCard.scss"],"names":[],"mappings":"AAAA;EACE,mBAAA;AACF;AAAE;EACE,gBAAA;EACA,uBAAA;EACA,oBAAA;EACA,qBAAA;EACA,aAAA;EACA,4BAAA;AAEJ;AACI;EACE,kBAAA;EACA,UAAA;EACA,SAAA;EACA,6BAAA;EACA,gDAAA;EACA,qBAAA;AACN","sourcesContent":[".safq-plugin-card {\n  margin-bottom: 10px;\n  .title {\n    overflow: hidden;\n    text-overflow: ellipsis;\n    display: -webkit-box;\n    -webkit-line-clamp: 2;\n    line-clamp: 2;\n    -webkit-box-orient: vertical;\n  }\n  .action {\n    button {\n      border-style: none;\n      padding: 0;\n      margin: 0;\n      background-color: transparent;\n      color: var(--store-addons-for-woocommerce-color);\n      text-decoration: none;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
